import React from 'react'
import 'bootstrap/dist/css/bootstrap.css'
import './App.css'
import Main from './Components/Main/Main';

function App() {
  
  return <Main></Main>
}

export default App;
